/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerAccountControllerDtoMyPasswordChangeRequest model module.
 * @module model/ManagerAccountControllerDtoMyPasswordChangeRequest
 * @version 1.0
 */
class ManagerAccountControllerDtoMyPasswordChangeRequest {
    /**
     * Constructs a new <code>ManagerAccountControllerDtoMyPasswordChangeRequest</code>.
     * @alias module:model/ManagerAccountControllerDtoMyPasswordChangeRequest
     * @param password {String} 
     * @param newPassword {String} 
     * @param twofaNo {String} 
     */
    constructor(password, newPassword, twofaNo) { 
        
        ManagerAccountControllerDtoMyPasswordChangeRequest.initialize(this, password, newPassword, twofaNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, password, newPassword, twofaNo) { 
        obj['password'] = password;
        obj['newPassword'] = newPassword;
        obj['twofaNo'] = twofaNo;
    }

    /**
     * Constructs a <code>ManagerAccountControllerDtoMyPasswordChangeRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerAccountControllerDtoMyPasswordChangeRequest} obj Optional instance to populate.
     * @return {module:model/ManagerAccountControllerDtoMyPasswordChangeRequest} The populated <code>ManagerAccountControllerDtoMyPasswordChangeRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerAccountControllerDtoMyPasswordChangeRequest();

            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('newPassword')) {
                obj['newPassword'] = ApiClient.convertToType(data['newPassword'], 'String');
            }
            if (data.hasOwnProperty('twofaNo')) {
                obj['twofaNo'] = ApiClient.convertToType(data['twofaNo'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerAccountControllerDtoMyPasswordChangeRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerAccountControllerDtoMyPasswordChangeRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerAccountControllerDtoMyPasswordChangeRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }
        // ensure the json data is a string
        if (data['newPassword'] && !(typeof data['newPassword'] === 'string' || data['newPassword'] instanceof String)) {
            throw new Error("Expected the field `newPassword` to be a primitive type in the JSON string but got " + data['newPassword']);
        }
        // ensure the json data is a string
        if (data['twofaNo'] && !(typeof data['twofaNo'] === 'string' || data['twofaNo'] instanceof String)) {
            throw new Error("Expected the field `twofaNo` to be a primitive type in the JSON string but got " + data['twofaNo']);
        }

        return true;
    }


}

ManagerAccountControllerDtoMyPasswordChangeRequest.RequiredProperties = ["password", "newPassword", "twofaNo"];

/**
 * @member {String} password
 */
ManagerAccountControllerDtoMyPasswordChangeRequest.prototype['password'] = undefined;

/**
 * @member {String} newPassword
 */
ManagerAccountControllerDtoMyPasswordChangeRequest.prototype['newPassword'] = undefined;

/**
 * @member {String} twofaNo
 */
ManagerAccountControllerDtoMyPasswordChangeRequest.prototype['twofaNo'] = undefined;






export default ManagerAccountControllerDtoMyPasswordChangeRequest;

